// ========== MAIN SWATCH SCRIPT ==========

window.initProductCardSwatches = function (context = document) {
  context.querySelectorAll('.product-card').forEach((card) => {
    const swatches = card.querySelectorAll('[data-variant-id]');

    swatches.forEach((swatch) => {
      if (swatch.dataset.swatchBound === 'true') return;
      swatch.dataset.swatchBound = 'true';

      swatch.addEventListener('click', () => {
        const name = swatch.name;
        const group = card.querySelectorAll(`input[name="${name}"]`);
        group.forEach(i => i.checked = false);
        swatch.checked = true;

        updateCardImages(card, swatch);
      });

      if (swatch.checked) {
        updateCardImages(card, swatch);
      }
    });
  });
};

function updateCardImages(card, swatch) {
  const primaryImage = card.querySelector('img.product-card__image--primary');

  let secondaryImage = card.querySelector('img.product-card__image--secondary--converse')
    || card.querySelector('img.product-card__image--secondary');

  if (!secondaryImage) {
    secondaryImage = document.createElement('img');
    secondaryImage.className = 'product-card__image product-card__image--secondary product-card__image--secondary--converse';
    const container = card.querySelector('.product-card__media') || card;
    container.appendChild(secondaryImage);
  }

  let mainJson = swatch.getAttribute('data-variant-media');
  let hoverJson = swatch.getAttribute('data-variant-hover-media');

  try {
    mainJson = mainJson ? JSON.parse(mainJson) : null;
    hoverJson = hoverJson ? JSON.parse(hoverJson) : null;
  } catch (e) {
    return;
  }

  if (mainJson?.preview_image?.src) {
    const mainSrc = mainJson.preview_image.src;

    if (primaryImage && mainSrc) {
      primaryImage.src = mainSrc;
      primaryImage.alt = mainJson.alt || primaryImage.alt;
    
      if (mainJson.preview_image.srcset) {
        primaryImage.srcset = mainJson.preview_image.srcset;
      }
    
      if (mainJson.preview_image.sizes) {
        primaryImage.sizes = mainJson.preview_image.sizes;
      }
    }

  }

  if (hoverJson?.preview_image?.src) {
    const hoverSrc = hoverJson.preview_image.src;
    secondaryImage.src = hoverSrc;
    secondaryImage.alt = hoverJson.alt || secondaryImage.alt;
  
    if (hoverJson.preview_image.srcset) {
      secondaryImage.srcset = hoverJson.preview_image.srcset;
    }
  
    if (hoverJson.preview_image.sizes) {
      secondaryImage.sizes = hoverJson.preview_image.sizes;
    }
  
    secondaryImage.classList.remove('fallback-image');
  }

}


function normalizeSrc(src) {
  return src.startsWith('//') ? 'https:' + src : src;
}

// ========== INITIALIZATION LOGIC ==========

document.addEventListener('DOMContentLoaded', () => {
  window.initProductCardSwatches();

  const globalCardObserver = new MutationObserver((mutations) => {
    let foundNewCard = false;

    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.matches && node.matches('.product-card, .product-card *')) {
            foundNewCard = true;
          }
        });
      }
    }

    if (foundNewCard) {
      window.initProductCardSwatches();
    }
  });

  globalCardObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// ========== FILTERING SUPPORT (Shopify's facet:update event) ==========

document.addEventListener('facet:update', (event) => {
  const facetFormBlock = document.querySelector('.shopify-section--main-collection');

  if (facetFormBlock) {
    const observer = new MutationObserver((mutations) => {
      window.initProductCardSwatches();
    });

    observer.observe(facetFormBlock, {
      childList: true,
      subtree: true
    });
  }
}, true);
